const AppRoute = {
  MAIN: '/',
  HEALING_NAVIGATOR: '/healing-navigator',
  FIND_A_PROFESSIONAL: '/physician-finder',
  HEALING_NAVIGATOR_INFORMATION: '/healing-navigator-information',
  LEARN_ABOUT_YOUR_WOUND: '/learn-about-your-wound',
  RESOURCES_SUPPORT: '/resources-support',
  GET_UPDATES: '/get-updates',
  HCP: '/hcp',
} as const;

export { AppRoute };
